export enum AdminActivityStepsTableColumnTitle {
  Step = "Korak",
  StepType = "Tip koraka",
  StepName = "Naziv koraka",
  Options = "",
}
